define((require) => {
    "use strict";

    var Backbone            = require("backbone"),
        _                   = require("underscore"),
        BreakpointGroup     = require("shared/ui/breakpoint/BreakpointGroup"),
        LocalizationGroup   = require("shared/services/localization/LocalizationGroup"),
        ExperienceModel     = require("shared/ui/experience/ExperienceModel"),
        ImageModel          = require("ui/assets/image/ImageModel"),
        Channel             = require("ui/publish/channelSetup/Channel");

    /**
     * @type {Object}
     * The currently supported asset types.
     */
    var Type = {
        BREAKPOINTGROUP:    "BreakpointGroup",
        LOCALIZATIONGROUP:  "LocalizationGroup",
        EXPERIENCE:         "Experience",
        IMAGE:              "Image",
        CHANNEL:            "Channel"
    };

    /**
     * @private @type {Map.<Function, String>}
     * Mapped constructor functions to asset types.
     */
    var types = new Map();

    types.set(BreakpointGroup,  Type.BREAKPOINTGROUP);
    types.set(LocalizationGroup, Type.LOCALIZATIONGROUP);
    types.set(ExperienceModel,  Type.EXPERIENCE);
    types.set(ImageModel,       Type.IMAGE);
    types.set(Channel,          Type.CHANNEL);

    /**
     * A project asset - consisting of an id and a type identifier.
     *
     * @class ProjectAsset
     * @constructor
     */
    var ProjectAsset = Backbone.Model.extend("Project Asset", {

        idAttribute: "resourceId",

        defaults: {

            /**
             * @type {String}
             * The asset ID.
             */
            resourceId: null,

            /**
             * @type {String}
             * The asset type, e.g. <tt>Experience</tt>.
             */
            resourceType: null
        }

    }, {
        Type: Type,

        /**
         * Whether the specified type is a valid asset type.
         *
         * @param  {String} type The asset type.
         * @return {Boolean}     <tt>true</tt> if the specified asset type is valid, i.e. one
         * of the <tt>Type.XXX</tt> constants values.
         */
        validType: function(type) {
            return _.contains(Type, type);
        },

        /**
         * Returns the asset type for the supplied model, or undefined if unknown.
         *
         * @param  {ImprovedModel|ImprovedModel[]|Backbone-} model The model entity to find the asset type for, e.g.
         *                                                         an <tt>ExperienceModel</tt> instance; cannot be falsey.
         * @return {String} The asset type (as a constant from <tt>ProjectAsset.TYPE</tt>, or undefined if
         *                  <tt>model</tt> is not a model doubling as an asset.
         * @throw  Error If <tt>model</tt> is not a valid type, including if falsey.
         */
        typeFromModel: function(model) {
            return types.get(model.constructor);
        },

        /**
         * Returns a new asset instance describing the supplied model, if possible. <p>
         *
         * If <tt>model</tt> is not a type that can be described as an asset, null will be returned. If <tt>model</tt>
         * does not have an id, or a temp id for non-saved identifiable types, null will be returned.
         *
         * @param {ImprovedModel|ImprovedModel[]|Backbone-} model The model to describe as a project asset; cannot
         *                                                        be falsey.
         * @return {ProjectAsset} A project asset describing <tt>model</tt>, or null if it cannot be represented as
         *                        an asset.
         * @throw  Error If <tt>model</tt> is not a valid type, including if falsey.
         */
        asAsset: function(model) {
            var id = model.identifier(), // also handles unsaved models...
                type = ProjectAsset.typeFromModel(model);

            return id && type ? new ProjectAsset({resourceId: id, resourceType: type}) : null;
        },

        /**
         * Normalize the model when handling project model and project assets.
         * @param {ProjectModel | ProjectModel[] | ProjectAsset | ProjectAsset[]} modelOrAsset An array or single project model or project asset..
         * @returns {ProjectModel[] | ProjectAsset[]} An array of project models or project assets.
         */
        toArray: function(modelOrAsset) {
            if (_.isArray(modelOrAsset)) {
                return modelOrAsset;
            }

            if (_.isArray(modelOrAsset.models)) {
                return modelOrAsset.models;
            }

            return [modelOrAsset];
        }
    });

    return ProjectAsset;
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/project/ProjectAsset.js